import { render } from "./SettingSubsidiary.vue?vue&type=template&id=5d2a8b4c"
import script from "./SettingSubsidiary.vue?vue&type=script&lang=js"
export * from "./SettingSubsidiary.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__